import type { AgentConnectionState } from "@/hooks/useLiveKitAgent";

export type VoiceSessionRecoveryKind = "connection" | "audio" | null;

interface ResolveVoiceSessionRecoveryKindOptions {
  audioTrackError?: string | null;
  connectionState: AgentConnectionState;
  isActiveSession: boolean;
  showInactiveSessionRecovery: boolean;
}

export function resolveVoiceSessionRecoveryKind({
  audioTrackError,
  connectionState,
  isActiveSession,
  showInactiveSessionRecovery,
}: ResolveVoiceSessionRecoveryKindOptions): VoiceSessionRecoveryKind {
  if (!isActiveSession && !showInactiveSessionRecovery) return null;
  if (connectionState === "failed") return "connection";
  if (audioTrackError) return "audio";
  return null;
}

interface ShouldAutoStartVoiceDemoOptions {
  connectionState: AgentConnectionState;
  hasAutoStarted: boolean;
  isConnected: boolean;
  isRecording: boolean;
  selectedLanguageCode?: string | null;
}

export function shouldAutoStartVoiceDemo({
  connectionState,
  hasAutoStarted,
  isConnected,
  isRecording,
  selectedLanguageCode,
}: ShouldAutoStartVoiceDemoOptions): boolean {
  return Boolean(
    selectedLanguageCode &&
    !hasAutoStarted &&
    connectionState === "disconnected" &&
    !isRecording &&
    !isConnected
  );
}

export function classifyVoiceSessionRecoveryError(error?: string | null): string {
  const normalized = String(error || "").toLowerCase();
  if (!normalized) return "unknown";
  if (normalized.includes("permission") || normalized.includes("notallowed")) {
    return "permission_denied";
  }
  if (
    normalized.includes("microphone") ||
    normalized.includes("audio") ||
    normalized.includes("device")
  ) {
    return "audio_device";
  }
  if (normalized.includes("timeout") || normalized.includes("timed out")) return "timeout";
  if (normalized.includes("network") || normalized.includes("fetch")) return "network";
  return "other";
}
